import React from 'react';
import { useFormikContext, ErrorMessage } from 'formik';
import { FormControl, FormLabel, Input, VStack, FormErrorMessage } from '@chakra-ui/react';

const Netcore = () => {
  const { values, setFieldValue, errors, touched } = useFormikContext();

  return (
    <VStack spacing={4} align="stretch">
      <FormControl isInvalid={errors.credentials?.name && touched.credentials?.name}>
        <FormLabel>Name</FormLabel>
        <Input
          value={values.credentials?.name || ''}
          onChange={(e) => setFieldValue('credentials.name', e.target.value)}
          placeholder="Configuration name"
        />
        <ErrorMessage name="credentials.name" component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.credentials?.apiKey && touched.credentials?.apiKey}>
        <FormLabel>API Key</FormLabel>
        <Input
          value={values.credentials?.apiKey || ''}
          onChange={(e) => setFieldValue('credentials.apiKey', e.target.value)}
          placeholder="Your Netcore API key"
        />
        <ErrorMessage name="credentials.apiKey" component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.credentials?.from && touched.credentials?.from}>
        <FormLabel>From Email</FormLabel>
        <Input
          value={values.credentials?.from || ''}
          onChange={(e) => setFieldValue('credentials.from', e.target.value)}
          placeholder="noreply@yourdomain.com"
        />
        <ErrorMessage name="credentials.from" component={FormErrorMessage} />
      </FormControl>

      <FormControl isInvalid={errors.credentials?.replyTo && touched.credentials?.replyTo}>
        <FormLabel>Reply To</FormLabel>
        <Input
          value={values.credentials?.replyTo || ''}
          onChange={(e) => setFieldValue('credentials.replyTo', e.target.value)}
          placeholder="support@yourdomain.com"
        />
        <ErrorMessage name="credentials.replyTo" component={FormErrorMessage} />
      </FormControl>
    </VStack>
  );
};

export default Netcore;